import { CSSProperties, MouseEventHandler, ReactNode } from 'react';
import { colors } from '@tempmee/tailwind';

interface IIconButtonProps {
  /** Icon rendered inside the button. */
  Icon: ReactNode;
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  ariaLabel?: string;
  dataTestId?: string;
  dataCy?: string;
  style?: CSSProperties;
}

/**
 * Rounded-square icon button from the new design kit (outlined, secondary
 * border). Named `IconButton` so the Figma component migration maps onto it.
 */
export const IconButton = ({
  Icon,
  onClick,
  disabled = false,
  ariaLabel,
  dataTestId,
  dataCy,
  style,
}: IIconButtonProps) => (
  <button
    type="button"
    aria-label={ariaLabel}
    data-testid={dataTestId}
    data-cy={dataCy}
    disabled={disabled}
    onClick={onClick}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 48,
      height: 48,
      borderRadius: 16,
      border: `1.5px solid ${colors.secondary[800]}`,
      backgroundColor: colors.shades[0],
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.4 : 1,
      ...style,
    }}
  >
    {Icon}
  </button>
);
